import {useEffect, useMemo} from "react"
import {useLocation} from "react-router-dom"
import Logger from "logger/logger"

export const OPERATION_LIST = 'list'
export const OPERATION_CREATE = 'create'
export const OPERATION_READ = 'read'
export const OPERATION_UPDATE = 'update'
export const OPERATION_DELETE = 'delete'
export const OPERATION_SETTINGS = 'settings'

export const SubWebPathService = {
  modulePath: 'modulePath',
  operation: 'operation',
  entityId: 'entityId',
}

function WebPathService(subscribe: string[], caller: string) {

  let location = useLocation()

  useEffect(() => {
    Logger(`Service.WebPath.init.${caller}`)
    return () => {
      Logger(`Service.WebPath.unloading.${caller}`)
    }
  }, [])

  const locArr = useMemo(() => {
    // Filter to remove empty '' items
    return location.pathname.split('/').filter(l => l)
  }, [location])

  const modulePath = useMemo(() => {
    if (subscribe.includes(SubWebPathService.modulePath)) {
      return locArr[0] ?? 'dashboard'
    }
    return ''
  }, [locArr])

  const operation = useMemo(function setOperation() {
    if (subscribe.includes(SubWebPathService.operation)) {
      return locArr[1] ?? OPERATION_LIST
    }
    return ''
  }, [locArr])

  const entityId = useMemo(() => {
    if (subscribe.includes(SubWebPathService.entityId)) {
      return locArr[2]
    }
    return ''
  }, [locArr])

  return {
    modulePath,
    operation,
    entityId,
  }

}

export default WebPathService
